export default __webpack_public_path__ + "static/media/jogging.5f88428c.jpg";